<template>
  <div class="card card-custom card-stretch gutter-b">
    <!--begin::Header-->
    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">
          Device
        </span>
      </h3>
      <div class="card-toolbar">
        <a href="/device" class="btn btn-success font-weight-bolder font-size-sm">
          <span class="svg-icon svg-icon-md svg-icon-white">
            <!--begin::Svg Icon | path:assets/media/svg/icons/Communication/Add-user.svg-->
            <inline-svg src="media/svg/icons/Devices/Server.svg" />
            <!--end::Svg Icon--> </span
          >Add Device</a
        >
      </div>
    </div>
    <!--end::Header-->
    <!--begin::Body-->
    <div class="card-body py-0">
      <!--begin::Table-->
      <div class="table-responsive">
        <table
          class="table table-head-custom table-vertical-center"
          id="kt_advance_table_widget_1"
        >
          <thead>
            <tr class="text-center">
              <th class="text-left">Device</th>
              <th class="text-center">Arah Angin</th>
              <th class="text-center">Kecepatan Angin</th>
              <th class="text-center">Curah Hujan</th>
              <th class="text-center">Suhu Udara</th>
              <th class="text-center">Kelembaban Udara</th>
              <th class="text-center">Tekanan Udara</th>
              <th class="text-center">Diperbaharui</th>
              <th class="text-center">STATUS</th>
              <th class="pr-0 text-right" style="min-width: 150px">aksi</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, i) in device">
              <tr v-bind:key="i">
                <td>
                  <a
                    href="#"
                    class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
                    >{{ item.device_id.toUpperCase() }}</a
                  >
                </td>

                <td class="text-center">
                  <a
                    href="#"
                    class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
                    >{{ item.data.wind_direction }} ° ({{ degToCompass(item.data.wind_direction) }})</a
                  >
                </td>

                <td class="text-center">
                  <a
                    href="#"
                    class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
                    >{{ item.data.wind_velocity_avg }} m/h</a
                  >
                </td>

                <td class="text-center">
                  <a
                    href="#"
                    class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
                    >{{ item.data.rainfall_hour }} mm</a
                  >
                </td>

                <td class="text-center">
                  <a
                    href="#"
                    class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
                    >{{ item.data.air_temperature }} C</a
                  >
                </td>

                <td class="text-center">
                  <a
                    href="#"
                    class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
                    >{{ item.data.air_humidity }} %</a
                  >
                </td>

                <td class="text-center">
                  <a
                    href="#"
                    class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
                    >{{ item.data.air_pressure }} mb</a
                  >
                </td>

                <td class="text-center">
                  <a
                    href="#"
                    class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
                    >{{ formatDateTime(item.data.created_at) }}</a
                  >
                </td>

                <td class="text-center">
                  <a
                    class="
                      text-dark-75
                      font-weight-bolder
                      text-hover-primary
                      mb-1
                      font-size-lg
                    "
                    ><span
                      class="label label-lg label-light-primary label-inline"
                      >{{ item.keterangan.toUpperCase() }}</span
                    ></a
                  >
                </td>

                <td class="pr-0 text-right">
                  <a
                    href="#"
                    class="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                  >
                    <span class="svg-icon svg-icon-md svg-icon-primary">
                      <inline-svg
                        src="media/svg/icons/Communication/Write.svg"
                      />
                    </span>
                  </a>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <!--end::Table-->
    </div>
    <!--end::Body-->
    <!--end::Advance Table Widget 2-->
  </div>
</template>

<script>
import { GET_DEVICE } from '../store/device.module.js';
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
export default {
  name: "widget-2",
  data() {
    return {
      checked: false,
      device: []
    };
  },
  created: function () {
    this.retrieveDevice();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Device" }]);
  },
  methods: {
    setCheck(checked) {
      this.checked = checked;
    },
    retrieveDevice() {
      this.$store.dispatch(GET_DEVICE).then(({ data }) => {
        this.device = data;
      });

    },
    formatDateTime(date){
      date = new Date(date).toLocaleString("id-ID")
      return date
    },
    degToCompass(num) {
      var val = Math.floor(num / 22.5 + 0.5);
      var arr = [
        "N",
        "NNE",
        "NE",
        "ENE",
        "E",
        "ESE",
        "SE",
        "SSE",
        "S",
        "SSW",
        "SW",
        "WSW",
        "W",
        "WNW",
        "NW",
        "NNW",
      ];
      return arr[val % 16];
    },
  }
};
</script>
